import { useLocale, useTranslations } from 'use-intl';
import { DEFAULT_LOCALE, isSupportedLocale } from '@financialharmony/i18n';
import { todoTitleText, type TodoTextMessages, type TodoTitleUnreadable } from '@financialharmony/ui';
import { captureError } from '@/lib/observability';
import type { TodoItem } from '@/types/todo';

// A payload the app cannot word shows the generic sentence; each distinct cause is reported once per
// page load, not on every render.
const reportedUnreadableTitles = new Set<string>();

function reportUnreadableTitle(reason: TodoTitleUnreadable, data: { kind: string; v?: number }) {
  const key = `${reason}:${data.kind}:${data.v ?? 1}`;
  if (reportedUnreadableTitles.has(key)) return;
  reportedUnreadableTitles.add(key);
  captureError(new Error(`todo title_data unreadable: ${key}`), 'todo-title-unreadable');
}

/** A todo's title in the language the app is showing: a system todo's data worded from the catalog, or its typed text. */
export function useTodoTitle() {
  const t = useTranslations('todoText');
  const locale = useLocale();
  const language = isSupportedLocale(locale) ? locale : DEFAULT_LOCALE;
  return (todo: Pick<TodoItem, 'title' | 'title_data'>) =>
    todoTitleText(
      t as unknown as TodoTextMessages,
      language,
      { title: todo.title, titleData: todo.title_data },
      reportUnreadableTitle,
    );
}
